<template>

  <div id="app" :style="styleObject">
    <router-view></router-view>
  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export const API_URL = 'https://learnandwatch.herokuapp.com'

export default {
  name: 'app',

  metaInfo: function () {
    return {
      title: this.title,
      meta: [
        {name: 'description', content: this.description},
        {property: 'og:title', content: this.title},
        {property: 'og:url', content: this.canonicalURL},
        {property: 'og:description', content: this.description},
        {property: 'og:image', content: this.imageLink},
      ]
    }
  },

  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    link: function () {
      return [{
        rel: 'canonical',
        href: this.canonicalURL,
        id: 'canonical'
      }]

    }
  },

  created: function () {
    this.setTitle()
    this.setDescription()
    this.setImageLink()
  },

  mounted() {
    if (window.matchMedia("(max-device-width: 767px)").matches) {
      this.set_isMobile(true)
    }
    else {
      this.set_isMobile(false)
    }

    window.addEventListener('resize', () => {
      if (window.matchMedia("(max-device-width: 767px)").matches) {
        this.set_isMobile(true)
      }
      else {
        this.set_isMobile(false)
      }
    }, false);


    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      this.getWindowWidth();
      this.getWindowHeight();
    })

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    //this.$tours['myTour'].start()
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
      'appStep',
      'authenticated',
      'profile',
      'states',
      'showsData',
      'seasonsData',
      'seasonsIndex',
      'kidsFilter',
      'stars',
      'level_copper',
      'level_silver',
      'level_gold',
      'auth0user',
      'dataLoaded',
      'routeParams',
      'routeName',
      'closableCardOpened',
      'carousselNav',
      'windowwidth',
      'windowheight',
      'navOpened'
    ]),
    ...mapGetters('blog', [
      'blogData',
      'blogDataLoaded',
      'currentArticle'
    ]),
    ...mapGetters('show', [
      'currentSeason',
      'seasonRequested',
      'currentShow',
      'currentEpisodeData',
    ]),
    ...mapGetters('session', [
      'currentWord',
      'currentComponent',
      'sessionFinished'
    ]),
    ...mapGetters('game', [
      'gameOn',
      'gameWordsList',
      'gameOrigin'
    ]),

    canonicalURL: function () {
      let url = 'https://www.learnandwatch.com/'
      if (this.routeName === 'blog' && this.routeParams.articleId !== undefined) {
          url += this.routeParams.articleId
      }
      return url;
    },


    styleObject: function () {
      if (this.currentShow.hue != undefined) {
        return {
          '--hue': this.currentShow.hue,
          '--hue2': (this.currentShow.hue-60)%360,
          '--hue3': (this.currentShow.hue+60)%360,
          '--hue4': (this.currentShow.hue+120)%360,
        }
      } else {
        return {
          '--hue': 158,
          '--hue2': (158+120)%360,
          '--hue3': (158+180)%360,
          '--hue4': (158-120)%360,
        }
      }

    },

    title: {
      get: function () {
        return this.pageTitle;
      },

      set: function (value) {
        this.pageTitle = value;
      }
    },

    description: {
      get: function () {
        return this.pageDescription;
      },

      set: function (value) {
        this.pageDescription = value;
      }
    },

    innerHeight: function () {
      return {'--trueHeight': window.innerHeight + 500}
    },
  },
  watch: {
    'gameOn': function () {
      if (!this.gameOn) {
        this.set_gameWordsList([])
      }
    }

  },

  methods: {
    ...mapActions('global', [
      'set_isMobile',
      'set_appStep',
      'set_authenticated',
      'set_profile',
      'set_userDatas',
      'change_userData',
      'set_cookieConsent',
      'set_kidsFilter',
      'set_stars',
      'set_level_copper',
      'set_level_silver',
      'set_level_gold',
      'set_auth0user',
      'set_catalogData',
      'set_showsData',
      'set_seasonsData',
      'update_showsData',
      'update_seasonsData',
      'set_apiDataKey',
      'set_dataLoaded',
      'set_closableCardOpened',
      'set_carousselNavTo',
      'set_carousselNavTransition',
      'set_windowwidth',
      'set_windowheight',
      'set_navOpened'
    ]),
    ...mapActions('blog', [
      'set_currentArticle',
      'set_blogData',
      'set_blogDataLoaded'
    ]),
    ...mapActions('show', [
      'set_currentSeason',
      'set_currentWordsLearnt',
      'set_wordsLearntLoaded',
      'set_seasonRequested',
      'set_currentShow',
      'set_currentSeasonLoaded',
      'set_currentEpisodeData',
      'add_currentEpisodeData',
    ]),
    ...mapActions('game', [
      'set_gameOn',
      'set_gameWordsList'
    ]),

    getWindowWidth() {
      this.set_windowwidth(Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
    },
    getWindowHeight() {
      this.set_windowheight(Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
    },

    // Définit les conditions d'attribution du titre de la page
    setTitle: function () {
      if (this.routeName === 'blog') {
        if (this.routeParams.articleId === undefined) {
          this.title = 'Blog de Learn and Watch'
        } else {
          this.title = this.currentArticle.content.title
        }
      } else {
        this.title = 'Learn and Watch | Apprends l\'anglais avec les séries'
      }
    },

    setDescription: function () {
      if (this.routeName === 'blog') {
        if (this.routeParams.articleId === undefined) {
          this.description = 'Blog de Learn and Watch'
        } else {
          this.description = this.currentArticle.content.title
        }
      } else {
        this.description = 'Apprendre et améliorer son anglais devient un jeu avec Learn and Watch. Découvre du vocabulaire spécifique à tes séries préférées et réponds à des questions de compréhension après chaque épisode.'
      }
    },
    // Définit les conditions d'attribution du titre de la page
    setImageLink: function () {

      if (this.routeName === 'season') {
        this.imageLink = 'https://learnandwatch.s3.eu-west-3.amazonaws.com/small/' + this.currentShow.poster_path
      } else {
        this.imageLink = 'https://learnandwatch.s3.eu-west-3.amazonaws.com/Logo_white_background.png'
      }
    }
  },

  data() {
    return {
      entryRoute: {
        name: 'home',
        first: true
      },
      pageTitle: 'Learn & Watch : apprendre et progresser en anglais avec les séries.',
      pageDescription: 'Apprendre ou améliorer son anglais devient un jeu avec Learn and Watch. Découvre du vocabulaire spécifique à tes séries préférées. Choisis ton épisode, et de façon ludique apprends des mots que tu y retrouveras.',
      canonicalUrl: '',

      tourOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'Passer la visite',
          buttonPrevious: 'Retour',
          buttonNext: 'Suivant',
          buttonStop: 'Fin'
        }
      },
      steps: [
        {
          target: '#logo',  // We're using document.querySelector() under the hood
          header: {
            title: 'Bienvenue sur Learn and Watch !',
          },
          content: 'Tu vas pouvoir apprendre le vocabulaire anglais difficile de tes séries préférées pour pouvoir les regarder facilement en VOST ensuite.'
        },
        {
          target: '#showsList_search',  // We're using document.querySelector() under the hood
          header: {
            title: 'Recherche',
          },
          content: 'Trouve la série Netflix que tu as déjà en tête...'
        },
        {
          target: '#showsList_levelSelect',  // We're using document.querySelector() under the hood
          header: {
            title: 'Recommandations par niveau',
          },
          content: '... ou suis nos recommandation de série adaptée à ton niveau !'
        },
        {
          target: '#showPoster_0',  // We're using document.querySelector() under the hood
          header: {
            title: 'Selection de série',
          },
          content: 'Choisi ta série, ...'
        },
        {
          target: '#attributes-row',  // We're using document.querySelector() under the hood
          header: {
            title: 'Des infos  !',
          },
          content: '... vérifie que tu seras à l\'aise, ...'
        },
        {
          target: '#summary',  // We're using document.querySelector() under the hood
          header: {
            title: 'Synopsis',
          },
          content: '... lis le synopsis pour plus de contexte, ...'
        },
        {
          target: '#learnButton',  // We're using document.querySelector() under the hood
          header: {
            title: 'Learn !',
          },
          content: '...puis démarre ta session de vocabulaire !'
        },
        {
          target: '#profilesilver',  // We're using document.querySelector() under the hood
          header: {
            title: 'Gagne des étoiles !',
          },
          content: 'Des étoiles bronze, argent et or pour les mots respectivements vus 1, 2 et 3 fois.'
        },
        {
          target: '#watchButton',  // We're using document.querySelector() under the hood
          header: {
            title: 'Watch !',
          },
          content: 'Tu peux ensuite aller voir ton épisode sur Netflix !'
        }

      ]
    }
  }
}

</script>

<style>

html {
  scroll-behavior: smooth;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  overflow: hidden;

  font-family: 'Nunito';
  font-size: 0.9vw;
  text-decoration: none;
  -webkit-font-smoothing: subpixel-antialiased;
  font-display: swap;


}

textarea:focus, input:focus{
  outline: none;
}

body {
  margin: 0px;
  font-size: 0.9vw;
  box-sizing: border-box;
}


h1, h2 {
  font-family: 'Montserrat';
  margin: 0;

}

h1 {
  font-size: 1.8vw;
}

h2 {
  font-size: 1.3vw;
}

h3 {
  margin: 0;
  font-weight: normal;
  font-size: 1vw;
}

span {
  text-decoration: none;
}

ul {
  list-style-type: '- ';
  font-style: italic;
  font-weight: bold;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: var(--goalBackgroundColor3);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 100vh;
  /*height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);*/
  width: 100vw;
}

.cookie-consent {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
#header {
  height: 4vw;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  position: absolute;
  top: 0;
}

#mainTrial {
  position: absolute;
  border-radius: 0 0 1vw 1vw;
  top: 0;
  width: 30vw;
  right: 23vw;
  padding: 0.5vw;
  text-align: center;
  align-items: center;
  align-content: center;
  display: flex;
  justify-content: center;
  z-index: 100000;
}



#profile_icon {
  margin-right: 2vw;
  z-index: 1;
  justify-content: flex-end;
}

#mainLevel {
  padding-right: 0.5vw;
  text-align: right;
}

#demolink {
  font-size: 1.1em;
}

#profilegold {
  background: var(--goldDarkBackground);
  color: var(--goldDarkColor);
  margin-right: 0.5vw;
}

#profilesilver {
  background: var(--silverDarkBackground);
  color: var(--silverDarkColor);
  margin-right: 0.5vw;
}

#profilecopper {
  background: var(--copperDarkBackground);
  color: var(--copperDarkColor);
  margin-right: 0.5vw;
}

.profile {
  position: relative;
  width: 3vw;
  height: 3vw;
  border-radius: 3vw;
  /*border: #6A3805 0.1vw solid;*/
  background-position: center;
  background-size: contain;
}

#premiumIcon {
  position: absolute;
  right: -0.5vw;
  top: -0.3vw;
  border-radius: 1vw;
  height: 1.2vw;
  width: 1.2vw;
  font-size: 0.7em;
  color: #ffda7b;
  background-color: hsl(200, 20%, 10%);
  margin-right: -2px;
}

.starcount {
  font-weight: bold;
  align-self: center;

}

#content {
  width: 100%;
  height:100%;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  z-index: 1;
  justify-content: center;

  /*box-sizing: border-box;
  border: 1px solid white;*/
}

#nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  /*justify-content: center;*/
  align-content: center;

  max-width: 22vw;
  width: fit-content;
  min-width: 22vw;
  max-height: calc(100% - 4vw);
  height: calc(100% - 4vw);
  padding-top: 4vw;

  /*box-sizing: border-box;
  border: 1px solid red;*/
}

/* slightly transparent fallback */
.backdrop-blur {
  background-color: var(--goalBackgroundColor);
}

/* if backdrop support: very transparent and blurred */
@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
  .backdrop-blur {
    background-color: var(--goalBackgroundColor);
    backdrop-filter: blur(0.75vw);
    -webkit-backdrop-filter: blur(0.75vw);
  }
}


#section {
  max-height: calc(100% - 4vw);
  height: calc(100% - 4vw);
  padding-top: 4vw;
  width: 78vw;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  /*box-sizing: border-box;
  border: 1px solid yellow;*/
  transition: all 0.5s;
}

#card {
  margin-top: auto;
  margin-bottom: auto;
  vertical-align: center;
  transition-property: left, right, top, bottom;
  transition-duration: 4s;
  align-content: center;
  display: flex;
  flex-wrap: wrap;
  max-height: calc(100% - 4vw);
  height: calc(100% - 4vw);
  padding-bottom: 4vw;
  width: 56vw;


  /*box-sizing: border-box;
  border: 1px solid yellow;*/
}

#undercard {
  height: 7vw;
  width: 58vw;

}

#footer {
  position: fixed;
  bottom: 1vw;
  right: 1vw;
  margin-right: 0vw;
  padding-right: 15px;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  z-index: 2;
}

.filterbutton {
  height: 1.1vw;
  min-width: 1.6vw;
  border-radius: 0.6vw;
  font-weight: bolder;
  font-size: 80%;
  margin-left: 0.25vw;
  margin-right: 0.25vw;
  padding: 0 0.3vw 0 0.3vw;
  align-self: center;
}

.simpleGrid {
  display: grid;
  grid-gap: 3vw;
  padding: 1vw 1vw 1vw 1vw;
  height: max-content;
  width: auto;
  /*height: 30vw;*/
  align-items: center;
  /*overflow: hidden;*/
}

::-webkit-scrollbar {
  width: 0.6vw;
  height: 0.6vw;
}

/* Track */
::-webkit-scrollbar-track {
  /*background: #eeeeee50;*/
}

/* Handle */
::-webkit-scrollbar-thumb {
  /*background: var(--watchColor2);*/
  background: var(--goalBackgroundColor);
}


/*/////////////////////////// Transitions ///////////////////////////////////////*/
.slide-item {
  transition: all 0.8s;
  /*display: inline-block;*/
}

.slide-enter, .slide-leave-to
  /* .slide-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateX(-50vw);
}

.slide-leave-active {
  position: absolute;
}

.slide-move {
  /*transition: transform 3s;*/
}

.slide-fade-enter-active {
  transition: all .6s;
  -webkit-transition: all .6s;
  -ms-transition: all .6s;
}

.slide-fade-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateX(3vw);
}

.slide-fade-left-enter-active {
  transition: all .6s;
  -webkit-transition: all .6s;
  -ms-transition: all .6s;
}

.slide-fade-left-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateX(-3vw);
}


.fadebg-item {
  transition: all .8s;
  -webkit-transition: all .8s;
  -ms-transition: all .8s;
  /*z-index:0;*/
}

.fadebg-enter, .fadebg-leave-to {
  opacity: 0;
  /*z-index:1;*/
}

.fadebg-leave-active {
  position: absolute;
}


.fade-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.fade-enter-active {
  transition: all .8s;
  -webkit-transition: all .8s;
  -ms-transition: all .8s;
}

.grow-enter {
  font-size: 1.2em;
}

.grow-enter-active {
  transition: all .5s;
  -webkit-transition: all .5s;
  -ms-transition: all .5s;
}

.fadedown-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(-10vw);

}

.fadedown-enter-active {
  transition: all .8s;
  -webkit-transition: all .8s;
  -ms-transition: all .8s;
}

.fadedown2-enter /* .fade-leave-active below version 2.1.8 */
{
  /*opacity: 0;*/
  transform: translateY(-1vw);

}

.fadedown2-enter-active {
  transition: all .8s;
  -webkit-transition: all .8s;
  -ms-transition: all .8s;
}

.fadeleave-leave-active {
  transition: all .8s;
  -webkit-transition: all .8s;
  -ms-transition: all .8s;
}

.fadeleave-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0.1;
}


.bordertest {
  border: 3px white solid;
}


/*/////////////////////////// Theme ///////////////////////////////////////*/

:root {
  --lightColor: hsla(330, 100%, 97%, 1);
  --lightplainColor: hsla(330, 100%, 87%, 1);
  --lightPinkColor: hsl(331, 92%, 90%);
  --darkPinkColor: hsl(332, 93%, 84%);
  --plainColor: hsla(190, 100%, 20%, 1);
  --darkBlue: #4050b4;
  --darkColor: hsla(50, 100%, 4%, 1);
  --lightGrey: #55555533;

  --goldBackground: hsl(50, 85%, 90%);
  --goldDarkBackground: hsl(42, 60%, 40%);
  --goldColor: hsl(25, 75%, 15%);
  --goldDarkColor: hsl(50, 85%, 95%);

  --silverBackground: hsl(200, 0%, 90%);
  --silverDarkBackground: hsl(200, 0%, 40%);
  --silverColor: hsl(30, 11%, 15%);
  --silverDarkColor: hsl(200, 0%, 95%);

  --copperBackground: hsl(14, 60%, 90%);
  --copperDarkBackground: hsl(18, 50%, 40%);
  --copperColor: hsl(0, 50%, 15%);
  --copperDarkColor: hsl(18, 60%, 95%);

  --standardBackground: var(--goalBackgroundColor3);
  --standardDarkBackground: hsl(220, 35%, 50%);
  --standardColor: hsl(330, 5%, 20%);
  --standardDarkColor: hsl(280, 60%, 95%);

  --borderWidth: 0.2vw;

  --learnColor: hsl(200, 90%, 55%);
  --watchColor: hsl(350, 89%, 58%);
  --learnColor2: hsl(200, 55%, 50%);
  --watchColor2: hsl(350, 55%, 45%);
  --correctAnswerColor: hsl(140, 95%, 60%);

  --goalColor: hsl(20, 45%,90%);
  --goalBackgroundColor: #309085;
  /*--goalBackgroundColor: hsl(330, 5%, 20%);*/
  --goalBackgroundColor2: hsl(5,60%,57%);
  --goalBackgroundColor3: hsl(20, 45%,90%);
  --goalBackgroundColor4: hsla(20, 100%,93%,0.75);

  --navBackgroundColor: hsl(210, 40%, 17%);

}

.whiteTheme {
  background: white;
  color: var(--darkColor);
  border-color: var(--copperDarkBackground);
}

.lightTheme {
  background: var(--lightColor);
  color: var(--darkColor);
  border-color: var(--copperDarkBackground);
}

.lightPinkTheme {
  background: var(--lightPinkColor);
  color: var(--darkColor);
  border-color: var(--copperDarkBackground);
}

.lightplainTheme {
  background: var(--goalBackgroundColor3);
  color: var(--navBackgroundColor);
  border-color: var(--navBackgroundColor);
}

.darkTheme {
  background: var(--darkColor);
  color: var(--lightColor);
  border-color: var(--copperDarkBackground);
}

.plainTheme {
  background: var(--plainColor);
  color: var(--lightColor);
  border-color: var(--copperDarkBackground);
}

.lightGoldTheme {
  background: var(--goldDarkBackground);
  color: var(--goldBackground);
  border-color: var(--goldColor);
}

.plainGoldTheme {
  background: var(--goldColor);
  color: var(--goldBackground);
  border-color: var(--goldBackground);
}

.darkGoldTheme {
  color: var(--goldColor);
}

.lightSilverTheme {
  background: var(--silverDarkBackground);
  color: var(--silverBackground);
  border-color: var(--silverColor);
}

.plainSilverTheme {
  background: var(--silverColor);
  color: var(--silverBackground);
  border-color: var(--silverBackground);
}

.darkSilverTheme {
  color: var(--silverColor);
}

.lightCopperTheme {
  background: var(--copperDarkBackground);
  color: var(--copperBackground);
  border-color: var(--copperColor);
}

.plainCopperTheme {
  background: var(--copperColor);
  color: var(--copperBackground);
  border-color: var(--copperBackground);
}

.darkCopperTheme {
  color: var(--copperColor);
}

.lightStandardTheme {
  background: var(--standardDarkBackground);
  color: var(--standardBackground);
  border-color: var(--standardColor);
}

.plainStandardTheme {
  background: var(--standardColor);
  color: var(--standardBackground);
  border-color: var(--standardColor);
}

.navTheme {
  background: var(--navBackgroundColor);
  color: var(--standardBackground);
  border-color: var(--navBackgroundColor);
}

.darkStandardTheme {
  color: var(--standardColor);
}

.profileCardTheme {
  color: #162327;
  border-color: #a55f3b;
  background-color: #eacda2;
}

.blue {
  color: hsl(200, 100%, 8%);
  background-color: var(--learnColor);
  box-shadow: 0 0.1vw 0.3vw 0 hsla(200, 80%, 30%, 0.3), 0 0.1vw 0.5vw 0 hsla(200, 80%, 30%, 0.3);
}

.red {
  color: hsl(350, 100%, 8%);
  background-color: #ff3a58;
  box-shadow: 0 0.1vw 0.3vw 0 hsla(350, 80%, 30%, 0.3), 0 0.1vw 0.5vw 0 hsla(350, 80%, 30%, 0.3);
}

.green {
  color: hsl(140, 100%, 8%);
  background-color: var(--correctAnswerColor);
  box-shadow: 0 0.1vw 0.3vw 0 hsla(140, 100%, 30%, 0.2), 0 0.1vw 0.5vw 0 hsla(140, 100%, 30%, 0.2);
}

.olive {
  background-color: var(--goalBackgroundColor);
  color: var(--goalColor);
  box-shadow: 0 0.1vw 0.3vw 0 hsla(140, 100%, 0%, 0.2), 0 0.1vw 0.5vw 0 hsla(140, 100%, 0%, 0.2);
}

.premium {
  color: #ffda7b;
  background-color: hsl(200, 20%, 15%);
}


.grey {
  color: var(--lightColor);
  background-color: var(--lightGrey);

}

/*// Shadow //*/
.smallShadow {
  box-shadow: 0 0.1vw 0.15vw 0 rgba(8, 8, 8, 0.4), 0 0.1vw 0.25vw 0 rgba(8, 8, 8, 0.4);
}

.mediumShadow {
  box-shadow: 0 0.2vw 0.11vw 0 rgba(4, 4, 4, 0.1), 0 0.2vw 0.85vw 0 rgba(4, 4, 4, 0.1);
}

.bigShadow {
  box-shadow: 0 0.3vw 0.7vw 0 rgba(0, 0, 0, 0.2), 0 0.3vw 1.5vw 0 rgba(0, 0, 0, 0.2);
}

/*// Angles //*/
.bigRoundAngles {
  border-radius: 1.4vw;
}

.mediumRoundAngles {
  border-radius: 1vw;
}

.SmallRoundAngles {
  border-radius: 0.7vw;
}

.smallRoundAngles {
  border-radius: 0.5vw;
}

.verySmallRoundAngles {
  border-radius: 0.5vw;
}

.flexwrap {
  display: flex;
  flex-wrap: wrap;
}

.flexwrapreverse {
  display: flex;
  flex-wrap: wrap;
}

.verticalFlex {
  display: flex;
  flex-direction: column;
}

.alignText {
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
}

.horizontalCenter {
  margin-left: auto;
  margin-right: auto;
}

.centercenter {
  align-self: center;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
}

.smallPaddingRound {
  padding: 0.1vw 0.25vw 0.1vw 0.25vw;
}

.paddingRound {
  padding: 0.2vw 0.5vw 0.2vw 0.5vw;
}

.bigPaddingRound {
  padding: 0.5vw 1vw 0.5vw 1vw;
}

.marginRound {
  margin: 0 0.5vw 0 0.5vw;
}

.gigMarginRound {
  margin: 0.5vw 1vw 0.5vw 1vw;
}

.smallMargin {
  margin: 0.25vw;
}

.centerBackground {
  background-blend-mode: darken;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.clickable {
  cursor: pointer;
}

.hidden {
  visibility: hidden;
}

.withBorder {
  border-style: solid;
  border-width: var(--borderWidth);
}


.fit {
  width: fit-content;
  height: fit-content;
}

.textShadow {
  text-shadow: 0px 0px 10px hsla(180, 25%,20%,0.8);
}

.softTextShadow {
  text-shadow: 0px 0px 16px hsla(180, 0%, 0%, 0.3);
}

.normalLink a {
  font-style: normal;
  text-decoration: none;
  color: var(--goalBackgroundColor3);
}


.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clamp1 {
  -webkit-line-clamp: 1;
}

.clamp2 {
  -webkit-line-clamp: 2;
}

.clamp5 {
  -webkit-line-clamp: 5;
}


/*Tooltip CSS ///////////////////////////////////////////////////////////////////////*/
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: var(--goalBackgroundColor3);
  color: var(--standardColor);
  font-weight: bold;
  border-radius: 8px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: var(--goalBackgroundColor3);
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: var(--goalBackgroundColor3);
  color: var(--standardColor);
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(var(--standardColor), .3);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.6s;
}


@media screen and (max-device-width: 767px) {

  html {
    font-size: 3.6vw;
  }

  body {
    font-size: 3.6vw;
  }

  h1 {
    font-size: 7.2vw;
  }

  h2 {
    font-size: 5.2vw;
  }

  h3 {
    font-size: 4vw;
  }

  :root {
    --borderWidth: 0.8vw;
  }

  #header {
    height: 13vw;
    min-height: 13vw;
    background-color: #101010;
  }

  #profilegold {
    margin-right: 2vw;
  }

  #profilesilver {
    margin-right: 2vw;
  }

  #profilecopper {
    margin-right: 2vw;
  }

  .profile {
    width: 10vw;
    height: 10vw;
    border-radius: 5vw;
  }

  #mainLevel {
    padding-right: 2vw;
    font-size: 0.9em;
  }

  #mainLevel > h2 {
    font-size: 1.3em;
  }


  #premiumIcon {
    position: absolute;
    right: -0.5vw;
    top: -0.5vw;
    border-radius: 4vw;
    height: 4.8vw;
    width: 4.8vw;
    font-size: 0.7em;
    margin-right: -2px;
  }


  .hero-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left center;
    background-blend-mode: saturation;
  }

  #content {
    width: 100%;
    min-height: calc(var(--vh, 1vh) * 100 - 25vw);
    height: calc(var(--vh, 1vh) * 100 - 25vw);
    max-height: calc(var(--vh, 1vh) * 100 - 25vw);
    padding-top: 13vw;
    display: block;
    flex-direction: row;
    justify-content: space-evenly;
    z-index: 1;
  }


  #nav {
    max-width: 100%;
    width: 100%;

    height: calc(var(--vh, 1vh) * 100 - 25vw);
    max-height: calc(var(--vh, 1vh) * 100 - 25vw);
    min-height: calc(var(--vh, 1vh) * 100 - 25vw);

    /*background-color: var(--goalBackgroundColor);*/
  }


  #prog {
    max-width: 100%;
    width: 100%;

    height: calc(var(--vh, 1vh) * 100 - 25vw);
    max-height: calc(var(--vh, 1vh) * 100 - 25vw);
    min-height: calc(var(--vh, 1vh) * 100 - 25vw);
    background-color: var(--goalBackgroundColor);
  }


  #section {
    width: fit-content;
    padding: 0;
  }

  #card {
    width: 100%;

    height: calc(var(--vh, 1vh) * 100 - 25vw);
    max-height: calc(var(--vh, 1vh) * 100 - 25vw);
    min-height: calc(var(--vh, 1vh) * 100 - 25vw);
  }

  #undercard {
    min-height: 0;
    max-height: 50vw;
    height: fit-content;
    width: 100%;
    justify-content: center;
  }

  .filterbutton {
    height: 5vw;
    min-width: 12vw;
    border-radius: 5vw;
    padding: 0 0.3vw 0 0.3vw;
    font-size: 90%;
  }


  ::-webkit-scrollbar {
    width: 1vw;
    height: 0.35vw;
  }

  /*// Angles //*/
  .bigRoundAngles {
    border-radius: 7.2vw;
  }

  .mediumRoundAngles {
    border-radius: 4.8vw;
  }

  .SmallRoundAngles {
    border-radius: 3.2vw;
  }

  .smallRoundAngles {
    border-radius: 2.4vw;
  }

  .verySmallRoundAngles {
    border-radius: 1vw;
  }

  /*// Padding //*/
  .smallPaddingRound {
    padding: 0.5vw 1.25vw 0.5vw 1.25vw;
  }

  .paddingRound {
    padding: 1vw 2.5vw 1vw 2.5vw;
  }

  .bigPaddingRound {
    padding: 2vw 4vw 2vw 4vw;
  }

  /*// Margin //*/
  .marginRound {
    padding: 0 1vw 0 1vw;
  }

  .bigMarginRound {
    padding: 2vw 4vw 2vw 4vw;
  }

  .smallMargin {
    margin: 1vw;
  }

  /*
  .standardButton {
    width: 30vw;
    height: 8vw;
    bottom: 15vh;
    left: 100vw;
    border-radius: 20vw;
  }*/
  .simpleGrid {
    grid-gap: 5vw;
    padding: 3vw;
  }



  ::-webkit-scrollbar {
    width: 2vw;
    height: 2vw;
  }

}


</style>
